<template>
  <router-view name="payment" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "Payment",
};
</script>
